const DEFAULT_LANGUAGE = process.env.GATSBY_DEFAULT_LANGUAGE

export const removeFoldersFromUrl = (url: string) => {
  if (typeof url !== 'string') return ''
  const folderPaths = ['website', '_components', DEFAULT_LANGUAGE]
  const pagePath = url.split('/')
  const filteredPath = pagePath.filter((pageSlug) => !folderPaths.includes(pageSlug)).join('/')
  return filteredPath.startsWith('/') ? filteredPath : `/${filteredPath}`
}
